import * as yup from "yup";

export const LoginSchema = yup.object().shape({
  email: yup.string().email().required().label("Email Address"),
  password: yup.string().min(8).max(20).required().label("Password"),
});
